// Helpers partagés du module Régie (formatage durée, drapeaux pays, heure).

export const fmtDuration = (ms) => {
  if (!ms || ms <= 0) return "—";
  const s = Math.round(ms / 1000);
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  const rs = s % 60;
  if (m < 60) return `${m}m ${rs}s`;
  const h = Math.floor(m / 60);
  return `${h}h ${m % 60}m`;
};

export const flagEmoji = (cc) => {
  if (!cc || cc.length !== 2) return "";
  try {
    return String.fromCodePoint(
      ...cc.toUpperCase().split("").map((c) => 127397 + c.charCodeAt(0))
    );
  } catch (e) {
    return "";
  }
};

export const fmtTime = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("fr-FR", {
      day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit",
    });
  } catch (e) {
    return iso.slice(0, 16);
  }
};

// Heure exacte (date + heure + seconde) — pour les événements de blocage
export const fmtTimeExact = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("fr-FR", {
      day: "2-digit", month: "2-digit", year: "numeric",
      hour: "2-digit", minute: "2-digit", second: "2-digit",
    });
  } catch (e) {
    return iso.slice(0, 19).replace("T", " ");
  }
};

export const fmtDateOnly = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("fr-FR", {
      day: "2-digit", month: "short", year: "numeric",
    });
  } catch (e) {
    return iso.slice(0, 10);
  }
};

// Liste rapide des pays UE + FR/BE/CH/US pour dropdown filtre country_code
export const COMMON_COUNTRIES = [
  { code: "FR", label: "France" },
  { code: "BE", label: "Belgique" },
  { code: "CH", label: "Suisse" },
  { code: "LU", label: "Luxembourg" },
  { code: "DE", label: "Allemagne" },
  { code: "IT", label: "Italie" },
  { code: "ES", label: "Espagne" },
  { code: "PT", label: "Portugal" },
  { code: "NL", label: "Pays-Bas" },
  { code: "GB", label: "Royaume-Uni" },
  { code: "US", label: "États-Unis" },
  { code: "CA", label: "Canada" },
];
